import {NavItem} from '@hconnect/uikit/src/lib2'
import {useTranslation} from 'react-i18next'

import {HROC_PREFIX} from '../../shared/consts'

import {TASKS_ROUTE} from './routes'

export const useTasksLinks = (): NavItem[] => {
  const {t} = useTranslation()

  const navItems: NavItem[] = [
    {
      url: TASKS_ROUTE,
      label: t(`${HROC_PREFIX}.navPages.tasks`)
    }
  ]

  return navItems
}
